// SegmentNote — the sentence that stops a combined top from passing itself off
// as a ranking. Shared by the Overview's Top 5 card and the Cycles panel
// because it is literally the same sentence in two places, and two copies of a
// sentence come apart on the first edit to either.

import type { NotePart } from "./segments";
import styles from "./SegmentNote.module.css";

export function SegmentNote({ parts }: { parts: NotePart[] }) {
  if (parts.length === 0) return null;
  return (
    <div className={styles.cardNote}>
      <svg
        width="13"
        height="13"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M12 16v-4M12 8h.01" />
      </svg>
      <span>
        {parts.map((p, i) =>
          p.strong ? <b key={i}>{p.text}</b> : <span key={i}>{p.text}</span>,
        )}
      </span>
    </div>
  );
}
